"use client"

import { clearZeroSession, onIdentityRequired } from "@/lib/zero-session-manager"
import { usePathname } from "next/navigation"
import { useEffect, useState } from "react"
import { AuthOverlay } from "./auth-overlay"

export function AutoSignIn() {
    const [showOverlay, setShowOverlay] = useState(false)

    const pathname = usePathname()
    const isPublic = ["/", "/privacy", "/terms", "/changelog", "/developers"].some(route => pathname === route || pathname?.startsWith(route + "/"))

    useEffect(() => {
        return onIdentityRequired(() => {
            if (isPublic) return
            setShowOverlay(true)
        })
    }, [isPublic])

    function handleLoginSuccess() {
        clearZeroSession()
        setShowOverlay(false)
    }

    return (
        <AuthOverlay
            isOpen={showOverlay}
            onClose={() => setShowOverlay(false)}
            onSuccess={handleLoginSuccess}
            allowClose={false}
        />
    )
}
